import React from 'react';

import { Department } from '../../../Types/department';
import { Project } from '../../../Types/project';

interface ProjectContextProps {
  projectId: string;
  project: Project;
  department: Department;
}

const ProjectContext = React.createContext<Partial<ProjectContextProps>>({});

export default ProjectContext;
